// extracted by mini-css-extract-plugin
module.exports = {"error":"CreateKiosk_error__3hrLJ","formControl":"CreateKiosk_formControl__3b360","buttonSaveBlock":"CreateKiosk_buttonSaveBlock__1HTa3"};